module.exports = __webpack_public_path__ + "assets/9cff89d8300010549a8d823f29e3ce0f.png";